import { INDUSTRIES_OF_INTEREST, INVESTMENT_AMOUNT_OPTIONS } from '@/constants'

/**
 * Props for ProfilePreferencesScreen component
 * Contains form state and handlers
 */
export interface ProfilePreferencesScreenBaseProps {
  formData: {
    first_name: string
    last_name: string
    job_title: string
    company_name: string
    country: string
    companies_of_interest_buy: string[]
    companies_of_interest_sell: string[]
    industries_of_interest: string[]
    preferred_investment_amount_min?: number
    preferred_investment_amount_max?: number
  }
  loading: boolean
  error: string
  onFormDataChange: (updates: Partial<ProfilePreferencesScreenBaseProps['formData']>) => void
  onAssetAdd: (type: 'buy' | 'sell', asset: string) => void
  onAssetRemove: (type: 'buy' | 'sell', asset: string) => void
  onIndustryToggle: (industry: string) => void
  onSelectAllIndustries: () => void
  onClearAllIndustries: () => void
  onSubmit: (e: React.FormEvent) => void
  onSkip: () => void
}

/**
 * Popular assets for quick selection
 */
export const POPULAR_ASSETS_BUY = ['Ethereum', 'Solana', 'Polygon', 'Arbitrum', 'Optimism', 'Chainlink']
export const POPULAR_ASSETS_SELL = ['Bitcoin', 'Ethereum', 'Solana', 'USDC', 'USDT']

/**
 * Default form data for profile preferences
 */
export const getDefaultProfilePreferencesFormData = (): ProfilePreferencesScreenBaseProps['formData'] => ({
  first_name: '',
  last_name: '',
  job_title: '',
  company_name: '',
  country: '',
  companies_of_interest_buy: [] as string[],
  companies_of_interest_sell: [] as string[],
  industries_of_interest: [] as string[],
  preferred_investment_amount_min: undefined,
  preferred_investment_amount_max: undefined
})

/**
 * Industries list
 */
export { INDUSTRIES_OF_INTEREST }

/**
 * Investment amount options
 */
export { INVESTMENT_AMOUNT_OPTIONS }

